import React from 'react'

import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'

import SubscriptionContainer from './SubscriptionPauseContainer'

export const SubscriptionPauseRollOutWrapper = () => {
  const isRolloutEnabled = useIsOptimizelyFeatureEnabled('is_subscription_pause_rollout_enabled')
  // Optimizely flag is null when the feature is not enabled
  const isLoadingRolloutFlag = typeof isRolloutEnabled !== 'boolean'

  if (isLoadingRolloutFlag) {
    return null
  }

  return (
    <>
      {!isRolloutEnabled && (
        <div data-testid="subscription-pause-rollout">
          <SubscriptionContainer />
        </div>
      )}
    </>
  )
}
